import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { platformStateSelector } from '@store/device-state';
import { useAppSelector } from '@store/hook';
import { FeaturePointProps } from './types';

const THEME_COLOR_CLASSES = [
  'iv-text-gradient-theme-dark-blue',
  'iv-text-gradient-theme-blue',
  'iv-text-gradient-theme-light-blue',
  'iv-text-gradient-theme-greenish-blue',
  'iv-text-gradient-theme-green',
  'iv-text-gradient-theme-light-green',
];

function Feature({
  image,
  title,
  highlightedContent,
  plainContent,
  idx,
}: FeaturePointProps) {
  const platform = useAppSelector(platformStateSelector);
  const { url, alt, width, height } = image[platform];
  return (
    <div className={ivclass('iv-pb-35 xl:iv-pb-40')}>
      <div
        className={ivclass(
          'iv-grid',
          'iv-grid-cols-6',
          'iv-items-center',
          'iv-gap-25',
        )}
      >
        <div
          className={ivclass(
            'iv-col-span-1',
            'iv-self-center',
            'iv-justify-self-end',
          )}
        >
          <div
            className={ivclass(
              'iv-relative',
              'iv-w-8 md:iv-w-12 lg:iv-w-14 xl:iv-w-14',
              'iv-h-32 md:iv-h-[48px] lg:iv-h-[56px] xl:iv-h-[56px]',
            )}
          >
            <ImageComponent
              elementype="native"
              className={ivclass('iv-mx-auto')}
              src={url}
              alt={alt}
              width={width}
              height={height}
              loading="lazy"
            />
          </div>
        </div>
        <h3
          className={ivclass(
            'iv-col-span-5',
            'iv-font-extrabold',
            idx < 6 ? THEME_COLOR_CLASSES[idx] : THEME_COLOR_CLASSES[5],
            'sm:iv-m-heading-4xs md:iv-m-heading-2xs lg:iv-m-heading-2xs xl:iv-m-heading-s',
            'sm:iv-text-heading-4xs md:iv-text-heading-2xs lg:iv-text-heading-2xs xl:iv-text-heading-s',
          )}
        >
          {title}
        </h3>
      </div>
      <div
        className={ivclass(
          'iv-grid',
          'iv-grid-cols-6',
          'iv-items-center',
          'iv-gap-20',
          'iv-pt-15',
        )}
      >
        <div
          className={ivclass(
            'iv-col-start-2 iv-col-span-5',
            'sm:iv-m-body-xl md:iv-m-body-3xl lg:iv-m-body-3xl xl:iv-m-body-3xl',
            'sm:iv-text-body-xl md:iv-text-body-3xl lg:iv-text-body-3xl xl:iv-text-body-3xl',
            'iv-font-medium',
          )}
        >
          {highlightedContent}
          <span className={ivclass('iv-text-black-70')}>{plainContent}</span>
        </div>
      </div>
    </div>
  );
}

export default Feature;
